import React, { useState, createContext, useEffect } from "react";
import scrollTo from "gatsby-plugin-smoothscroll"

const FormContext = createContext();

export const FormProvider = ({ children }) => {

    const windowGlobal = typeof window !== 'undefined' && window;

    const initialState = {
        step: 1,
        product: '',
        name: '',
        notes: '',
        email: '',
        totalPrice: 0,
        finalProduct: '',
        wantSubscribeToNewsletter: false
    };

    const [state, setState] = useState(initialState);
    const [dollarPrice, setDollarPrice] = useState(null);
    const [modelOpen, setModalOpen] = useState(false);

    const commonBriefState = {
        companyName: '',
        socialMedia: '',
        brandResources: '',
        designTastes: '',
        uniqueAttributes: '',
        anythingElse: ''
    };

    const commonPayload = {
        dollarPrice,
        name: state.name,
        firstName: state.name.split(' ')[0],
        email: state.email,
        product: state.product,
        totalPrice: state.totalPrice,
        wantSubscribeToNewsletter: state.wantSubscribeToNewsletter
    }

    const websiteState = {
        priceWebsitePages: '',
        priceWebsiteForm: '',
        priceWebsiteBlog: '',
        priceWebsiteConsultation: '',
        priceWebsiteNewsletter: '',
        priceWebsiteChat: '',
        multiplierWebsiteLanguages: '',
        multiplierWebsiteCMS: '',
        multiplierWebsiteDarkMode: '',
        multiplierWebsiteAnimations: '',
        multiplierWebsiteProject: '',
        ...commonBriefState,
        purpose: '',
        targetGroup: '',
        clientsProblems: '',
        concurrencyWebsites: '',
        websiteMap: ''
    },
    priceWebsiteFixedCosts =
        state.priceWebsitePages +
        state.priceWebsiteForm +
        state.priceWebsiteBlog +
        state.priceWebsiteNewsletter +
        state.priceWebsiteChat,
    priceWebsiteMultipliers =
        state.multiplierWebsiteLanguages *
        state.multiplierWebsiteCMS *
        state.multiplierWebsiteDarkMode *
        state.multiplierWebsiteAnimations *
        state.multiplierWebsiteProject,
    priceWebsiteCondition = ([state.priceWebsitePages, state.priceWebsiteForm, state.priceWebsiteBlog, state.priceWebsiteNewsletter, state.priceWebsiteChat, state.multiplierWebsiteLanguages, state.multiplierWebsiteCMS, state.multiplierWebsiteDarkMode, state.multiplierWebsiteProject].includes('')),
    websitePayload = {
        ...commonPayload,
        priceWebsitePages: state.priceWebsitePages,
        priceWebsiteForm: state.priceWebsiteForm,
        priceWebsiteBlog: state.priceWebsiteBlog,
        priceWebsiteNewsletter: state.priceWebsiteNewsletter,
        priceWebsiteChat: state.priceWebsiteChat,
        multiplierWebsiteLanguages: state.multiplierWebsiteLanguages,
        multiplierWebsiteCMS: state.multiplierWebsiteCMS,
        multiplierWebsiteDarkMode: state.multiplierWebsiteDarkMode,
        multiplierWebsiteAnimations: state.multiplierWebsiteAnimations,
        multiplierWebsiteProject: state.multiplierWebsiteProject,
        product: state.product,
        companyName: state.companyName,
        socialMedia: state.socialMedia,
        purpose: state.purpose,
        clientsProblems: state.clientsProblems,
        concurrencyWebsites: state.concurrencyWebsites,
        brandResources: state.brandResources,
        designTastes: state.designTastes,
        targetGroup: state.targetGroup,
        uniqueAttributes: state.uniqueAttributes,
        websiteMap: state.websiteMap,
        anythingElse: state.anythingElse,
    }

    const landingPageState = {
        multiplierLandingPageCMS: '',
        multiplierLandingPageProject: '',
        priceLandingPageGoal: '',
        ...commonBriefState
    },
    priceLandingPageFixedCosts =
        state.priceLandingPageGoal,
    priceLandingPageMultipliers =
        state.multiplierLandingPageCMS *
        state.multiplierLandingPageProject,
    priceLandingPageCondition = ([state.priceLandingPageGoal, state.multiplierLandingPageCMS, state.multiplierLandingPageProject]).includes(''),
    landingPagePayload = {
        ...commonPayload,
        priceLandingPageGoal: state.priceLandingPageGoal,
        multiplierLandingPageProject: state.multiplierLandingPageProject,
        multiplierLandingPageCMS: state.multiplierLandingPageCMS,
        companyName: state.companyName,
        targetGroup: state.targetGroup,
        socialMedia: state.socialMedia,
        brandResources: state.brandResources,
        designTastes: state.designTastes,
        uniqueAttributes: state.uniqueAttributes,
        anythingElse: state.anythingElse,
    }


    const eCommerceState = {
        multiplierEcommerceProductsCount: '',
        priceEcommerceControlProductsDetails: '',
        priceEcommerceAccountRegistration: '',
        priceEcommerceDiscounts: '',
        priceEcommerceStockAvailability: '',
        priceEcommerceLabelProducts: '',
        priceEcommerceIntegration: '',
        priceEcommerceVariants: '',
        priceEcommerceSearchBar: '',
        ...commonBriefState,
        concurrencyWebsites: '',
        ecommerceMap: '',
    },
    priceEcommerceFixedCosts =
        state.priceEcommerceControlProductsDetails +
        state.priceEcommerceAccountRegistration +
        state.priceEcommerceDiscounts +
        state.priceEcommerceStockAvailability +
        state.priceEcommerceLabelProducts +
        state.priceEcommerceIntegration +
        state.priceEcommerceVariants +
        state.priceEcommerceSearchBar,
    priceEcommerceMultipliers =
        state.multiplierEcommerceProductsCount,
    priceEcommerceCondition = ([state.multiplierEcommerceProductsCount, state.priceEcommerceControlProductsDetails, state.priceEcommerceAccountRegistration, state.priceEcommerceDiscounts, state.priceEcommerceStockAvailability, state.priceEcommerceLabelProducts, state.priceEcommerceIntegration, state.priceEcommerceVariants, state.priceEcommerceSearchBar].includes('')),
    ecommercePayload = {
        ...commonPayload,
        multiplierEcommerceProductsCountNumber: state.multiplierEcommerceProductsCountNumber,
        priceEcommerceControlProductsDetails: state.priceEcommerceControlProductsDetails,
        priceEcommerceAccountRegistration: state.priceEcommerceAccountRegistration,
        priceEcommerceDiscounts: state.priceEcommerceDiscounts,
        priceEcommerceStockAvailability: state.priceEcommerceStockAvailability,
        priceEcommerceLabelProducts: state.priceEcommerceLabelProducts,
        priceEcommerceIntegration: state.priceEcommerceIntegration,
        priceEcommerceVariants: state.priceEcommerceVariants,
        priceEcommerceSearchBar: state.priceEcommerceSearchBar,
        companyName: state.companyName,
        socialMedia: state.socialMedia,
        concurrencyWebsites: state.concurrencyWebsites,
        brandResources: state.brandResources,
        designTastes: state.designTastes,
        targetGroup: state.targetGroup,
        uniqueAttributes: state.uniqueAttributes,
        ecommerceMap: state.ecommerceMap,
        anythingElse: state.anythingElse,
    }

    const webAppState = {
        priceWebAppLogin: '',
        priceWebAppUserProfiles: '',
        priceWebAppDashboard: '',
        priceWebAppApiIntegration: '',
        priceWebAppPayments: '',
        multiplierWebAppUserRoles: '',
        ...commonBriefState,
    },
    priceWebAppFixedCosts =
        state.priceWebAppLogin +
        state.priceWebAppUserProfiles +
        state.priceWebAppDashboard +
        state.priceWebAppApiIntegration +
        state.priceWebAppPayments,
    priceWebAppMultipliers =
        state.multiplierWebAppUserRoles,
    priceWebAppCondition = ([
        state.priceWebAppLogin,
        state.priceWebAppUserProfiles,
        state.priceWebAppDashboard,
        state.priceWebAppApiIntegration,
        state.priceWebAppPayments,
        state.multiplierWebAppUserRoles
    ].includes('')),
    webAppPayload = {
        ...commonPayload,
        priceWebAppLogin: state.priceWebAppLogin,
        priceWebAppUserProfiles: state.priceWebAppUserProfiles,
        priceWebAppDashboard: state.priceWebAppDashboard,
        priceWebAppApiIntegration: state.priceWebAppApiIntegration,
        priceWebAppPayments: state.priceWebAppPayments,
        multiplierWebAppUserRoles: state.multiplierWebAppUserRoles,
        ...commonBriefState,
    }

    const AllStatesForReset = {
        ...initialState,
        ...websiteState,
        ...landingPageState,
        ...eCommerceState,
        ...webAppState,
        ...websiteState
    },
    allStateValues = Object.keys(AllStatesForReset);

    const AllStateAnswersForReset = {
        ...websiteState,
        ...landingPageState,
        ...eCommerceState,
        ...webAppState,
        ...websiteState
    },
    allStateAnswers = Object.keys(AllStateAnswersForReset);

    const getAllSteps = () => {
        switch(state.product) {
            default:
                return 0
            case 'website_type':
                return 1
            case 'website':
                return 11
            case 'website_brief':
                return 13
            case 'landing_page':
                return 3
            case 'ecommerce':
                return 9
            case 'webapp':
                return 6
            case 'personal-data':
                return 4
        }
    }

    const chooseProduct = (product, step = 1) => {
        scrollTo('body');
        switch(product) {
            default:
                setState({
                    ...state,
                    step: step,
                    product: product
                });
                break
            case 'website':
                setState({
                    ...initialState,
                    ...state.totalPrice,
                    ...websiteState,
                    step: step,
                    product: product
                });
                break
            case 'landing_page':
                setState({
                    ...initialState,
                    ...landingPageState,
                    step: step,
                    product: product
                });
                break
            case 'ecommerce':
                setState({
                    ...initialState,
                    ...eCommerceState,
                    step: step,
                    product: product
                });
                break
            case 'webapp':
                setState({
                    ...initialState,
                    ...webAppState,
                    step: step,
                    product: product
                });
                break
        }
        // windowGlobal.localStorage.setItem('product', product)
    };
    
    useEffect(() => {
        // setTimeout(() => {
        //     const textarea = document.querySelector('.valform-textarea');
        //     const input = document.querySelector('.valform-input');

        //     if (textarea) {
        //         textarea.focus();
        //     }
        //     if (input) {
        //         input.focus();
        //     }
        // }, 2000); // Small delay to ensure the element is ready for focus
    }, [state.step]);

    const nextStep = () => {
        scrollTo('body');
        const { step } = state;
        setState({
            ...state,
            step: step + 1
        });
        
        // windowGlobal.localStorage.setItem('step', state.step);
    };

    const prevStep = () => {
        scrollTo('body');
        const { step } = state;
        setState({
            ...state,
            step: step - 1
        });
        // windowGlobal.localStorage.setItem('step', state.step);
    };

    const backToFirstQuestion = (product = '', step = 2) => {
        scrollTo('body');
        setState({
            ...state,
            product: product,
            step: step
        });
    };

    const resetForm = () => {
        scrollTo('body');
        setState(initialState);
        allStateValues.forEach(item => windowGlobal.localStorage.removeItem(item));
    };

    const resetAnswers = () => {
        scrollTo('body');
        setState({
            ...state,
            ...websiteState,
            ...landingPageState,
            ...eCommerceState,
            ...webAppState,
            ...commonBriefState
        })
        allStateAnswers.forEach(item => windowGlobal.localStorage.removeItem(item));
    }

    const handleChange = input => e => {
        e.persist();
        scrollTo('body');
        const { step } = state;
        let { value } = e.target;
        value = parseFloat(value);
        setState({
            ...state,
            [input]: value,
            step: step + 1
        });
        windowGlobal.localStorage.setItem(input, value);
    };

    const handleChangeString = input => e => {
        e.persist();
        scrollTo('body');
        const { step } = state;
        setState({
            ...state,
            [input]: e.target.value,
            step: step + 1
        });
        windowGlobal.localStorage.setItem(input, e.target.value);
    };

    const handleChangeTextarea = input => e => {
        scrollTo('body');
        e.persist();
        setState({
            ...state,
            [input]: e.target.value
        });
        windowGlobal.localStorage.setItem(input, e.target.value);
    };

    const missingAnswers = (currentState) => {
        scrollTo('body');
        let states;
        if (currentState === 'website') states = Object.keys(websiteState)
        if (currentState === 'landing_page') states = Object.keys(landingPageState)
        if (currentState === 'ecommerce') states = Object.keys(eCommerceState)
        if (currentState === 'webapp') states = Object.keys(webAppState)
        let indexes = [];
        states.forEach((singleState, index) => {
            if (state[singleState] === '') {
                let indexPlusOne = index + 1;
                indexes.push(indexPlusOne);
            }
        })
        const lowestInArray = Math.min.apply(null, indexes);
        setState({
            ...state,
            step: lowestInArray
        })
    };

    const submitForm = (product) => {
        setState({
            ...state,
            product: product
        })
        windowGlobal.localStorage.setItem('name', state.name);
    };

    function getDollarPrice() {
        fetch('https://api.nbp.pl/api/exchangerates/rates/A/USD/')
            .then(response => response.json())
            .then(result => setDollarPrice(result.rates[0].mid))
            .catch(() => setDollarPrice(3.95));
    };

    return (
        <FormContext.Provider value={{
            state,
            setState,
            modelOpen,
            setModalOpen,
            priceWebsiteFixedCosts,
            priceWebsiteMultipliers,
            priceWebsiteCondition,
            websitePayload,
            priceLandingPageFixedCosts,
            priceLandingPageMultipliers,
            priceLandingPageCondition,
            landingPagePayload,
            priceEcommerceFixedCosts,
            priceEcommerceMultipliers,
            priceEcommerceCondition,
            ecommercePayload,
            priceWebAppFixedCosts,
            priceWebAppMultipliers,
            priceWebAppCondition,
            webAppPayload,
            windowGlobal,
            getAllSteps,
            nextStep,
            prevStep,
            handleChange,
            handleChangeString,
            handleChangeTextarea,
            backToFirstQuestion,
            missingAnswers,
            chooseProduct,
            resetForm,
            resetAnswers,
            submitForm,
            getDollarPrice,
            dollarPrice,
        }}>
            {children}
        </FormContext.Provider>
    )};

export default FormContext;